module.exports = __webpack_public_path__ + "img/virgule-big-grey.f4016f2e.svg";